import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconAiCommentMono = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.6665 1.66675C5.6665 1.39061 5.44265 1.16675 5.1665 1.16675C4.89036 1.16675 4.6665 1.39061 4.6665 1.66675V2.16675H4.1665C3.89036 2.16675 3.6665 2.39061 3.6665 2.66675C3.6665 2.94289 3.89036 3.16675 4.1665 3.16675H4.6665V3.66675C4.6665 3.94289 4.89036 4.16675 5.1665 4.16675C5.44265 4.16675 5.6665 3.94289 5.6665 3.66675V3.16675H6.1665C6.44265 3.16675 6.6665 2.94289 6.6665 2.66675C6.6665 2.39061 6.44265 2.16675 6.1665 2.16675H5.6665V1.66675Z",
			fill: "#C084FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.8335 6.5C3.8335 6.22386 3.60964 6 3.3335 6C3.05735 6 2.8335 6.22386 2.8335 6.5V7H2.3335C2.05735 7 1.8335 7.22386 1.8335 7.5C1.8335 7.77614 2.05735 8 2.3335 8H2.8335V8.5C2.8335 8.77614 3.05735 9 3.3335 9C3.60964 9 3.8335 8.77614 3.8335 8.5V8H4.3335C4.60964 8 4.8335 7.77614 4.8335 7.5C4.8335 7.22386 4.60964 7 4.3335 7H3.8335V6.5Z",
			fill: "#C084FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.74599 8.07729C9.07143 8.40273 9.07143 8.93037 8.74599 9.2558L3.08914 14.9127C2.7637 15.2381 2.23607 15.2381 1.91063 14.9127C1.58519 14.5872 1.58519 14.0596 1.91063 13.7341L7.56748 8.07729C7.89292 7.75186 8.42056 7.75186 8.74599 8.07729Z",
			fill: "#C084FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9083 1.34533C12.2804 0.750301 13.1979 0.996166 13.2226 1.69748L13.2671 2.96357C13.2803 3.33687 13.5798 3.63645 13.9531 3.64958L15.2192 3.6941C15.9205 3.71877 16.1664 4.63635 15.5714 5.00837L14.4972 5.67998C14.1805 5.878 14.0708 6.28723 14.2461 6.61708L14.8406 7.73581C15.1699 8.3555 14.4982 9.02722 13.8785 8.69792L12.7597 8.10344C12.4299 7.92816 12.0207 8.03782 11.8226 8.35454L11.151 9.42874C10.779 10.0238 9.86142 9.7779 9.83676 9.07658L9.79223 7.8105C9.7791 7.4372 9.47952 7.13761 9.10622 7.12448L7.84014 7.07996C7.13882 7.05529 6.89295 6.13771 7.48798 5.76569L8.56218 5.09408C8.8789 4.89606 8.98855 4.48683 8.81327 4.15698L8.21879 3.03825C7.8895 2.41856 8.56122 1.74684 9.18091 2.07614L10.2996 2.67062C10.6295 2.8459 11.0387 2.73624 11.2367 2.41952L11.9083 1.34533Z",
			fill: "#C084FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.1665 11.1667C13.1665 10.8906 12.9426 10.6667 12.6665 10.6667C12.3904 10.6667 12.1665 10.8906 12.1665 11.1667V11.6667H11.6665C11.3904 11.6667 11.1665 11.8906 11.1665 12.1667C11.1665 12.4429 11.3904 12.6667 11.6665 12.6667H12.1665V13.1667C12.1665 13.4429 12.3904 13.6667 12.6665 13.6667C12.9426 13.6667 13.1665 13.4429 13.1665 13.1667V12.6667H13.6665C13.9426 12.6667 14.1665 12.4429 14.1665 12.1667C14.1665 11.8906 13.9426 11.6667 13.6665 11.6667H13.1665V11.1667Z",
			fill: "#C084FC"
		})
	]
});
export default SvgIconAiCommentMono;
